<app-header class="site-header fixed-menu"  [ngClass]="{'scrolled': isScrolled}"></app-header>
<section class="main-body-section">
    <router-outlet></router-outlet>
</section>
<app-footer></app-footer>

<app-modal-popup></app-modal-popup>